import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal,Spinner } from "react-bootstrap";
import C from '../lib/Config';
import SuccessAlert from './SuccessAlert';

export default class TerminateProtocol extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCommentBox: false,
            saveLoader: false,
            successAlertshow: false,
            successAlertclose: false,
            terminationCommentsErrors: [],
            terminationComments:'',
            patTreatPlanId:this.props.treatPlanId,
            patientId:this.props.patientId,
            doctorId:this.props.doctorId

        };
        this.radioChange = this.radioChange.bind(this);
    }
    radioChange(event) {
        if(event.target.value==='Other'){
            this.setState({ showCommentBox: true });
            this.setState({'terminationComments':null});
        }else{
            this.setState({ showCommentBox: false });
            this.setState({'terminationComments':event.target.value});
        }
    }
    validateTerminateProtocol() {
        let formIsValid = true;
        let errors = {};
        if (this.state.terminationComments === null || this.state.terminationComments === "" || this.state.terminationComments === "DEFAULT") {
            errors["terminationComments"] = "Please choose a reason to terminate protocol";
            formIsValid = false;
        }
        this.setState({ terminationCommentsErrors: errors });
        return formIsValid;
    }
    confirm(){
        let isThisValidForm = false;
        if (this.validateTerminateProtocol()) {
            isThisValidForm = true;
        }
        let data = {
            patientTreatmentPlanId: this.props.treatPlanId,
            terminationComments:this.state.terminationComments,
            patientDTO: {
                patientID: this.props.patientId
            },
            updatedByIdUser:{
                userId: this.props.doctorId
            }
        }
        if (isThisValidForm) {
            return fetch(C.getUrl() + '/userCase/terminateTreatment', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    alert(error);
                } else {
                    if (obj.statusCode == 200) {
                        this.setState({ saveLoader: true, successAlertshow: true });
                        setTimeout(() => {
                            this.setState({ saveLoader: false, successAlertshow: false })
                        }, 3000)
                    }
                    this.props.closeModal();
                    window.location.reload();
                }
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
        } 
    }
    render() {
        const { showTerminateProtocol, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const { showCommentBox } = this.state;
        return (
            <div>
                <Modal id="report" show={showTerminateProtocol} centered animation={true} scrollable={true} size="md">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Terminate Protocol</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg='12'>
                                    <div className="">
                                        <Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Treatment completed as per plan" label="Treatment completed as per plan" />
                                        <Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Adverse Event Observed" label="Adverse Event Observed" />
                                        <Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Patient Died" label="Patient Died" />
                                        <Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Lost to followup" label="Lost to followup" />
                                        <Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Other" label="Other (specify)" />
                                    </div>
                                </Col>
                                <Col lg='12'>
                                    {
                                    (showCommentBox) ?
                                        <Form.Group>
                                            <Form.Control as='textarea' placeholder='Please specify ' name='docName' onChange={(e)=>this.setState({'terminationComments':e.target.value})}/>
                                        </Form.Group>
                                        : null
                                    }
                                    <div className="invalid-feedback">{this.state.terminationCommentsErrors["terminationComments"]}</div>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <Button className="btn btn-secondary" onClick={() => this.confirm()}> 
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Confirm 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
                <SuccessAlert show={this.state.successAlertshow} alertBody={'Treatment terminated successfully'} />
            </div>
        )
    }
}